/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22.1181 1.8614 2.446 8.8045l8.4845 3.1818 3.5387-3.5387a.7754.7754 0 1 1 1.0966 1.0966l-3.56 3.56 2.6146 8.3666 7.4977-19.6094ZM10.4987 13.4806.7044 9.8078c-.949-.356-.9359-1.7029.0199-2.0402L22.5507.0642c.8726-.308 1.7058.547 1.3753 1.4113L15.5902 23.277c-.3678.9619-1.743.919-2.0502-.0639l-3.0413-9.7324Z"
    clipRule="evenodd"
  />,
  'Send'
);
